import React, { Component } from "react";
import MyContext from '../MyContext.jsx';
import { Link } from "react-router-dom";
import { CgSearch } from 'react-icons/cg';
import Select from "react-select";
import DatePicker from 'react-date-picker';
import InfiniteScroll from 'react-infinite-scroll-component';

import './OutstandingForecast.scss';
import Loader from "../Loading/Loader.jsx";
import { resetScroll } from "../Utility/resetScroll.js";

class OutstandingForecast extends Component {
  constructor(props) {
    super(props);

    const today = new Date();
    // Default from_date: 1st of current month
    const from_date = new Date(today.getFullYear(), today.getMonth(), 1);
    // Default to_date: end of current month
    const to_date = new Date(today.getFullYear(), today.getMonth() + 1, 0);

    this.state = {
      districts: [],
      district: null,
      all_customers: [],
      customer: null,
      till_date: true,
      from_date: from_date,
      to_date: to_date,

      cost_centers: [],
      showing_cost_centers: [],

      outstanding: 0,
      due_exceed: 0,
      bill_total: 0,

      showing_outstanding: 0,
      showing_due_exceed: 0,
      showing_bill_total: 0,

      customer_search: "",
      invoice_search: "",
      active_tab: "1" // Default to Detailed Forecast
    };

    this.districtChange = this.districtChange.bind(this);
    this.customerChange = this.customerChange.bind(this);
    this.handleTillDateToggle = this.handleTillDateToggle.bind(this);
    this.fromDateChange = this.fromDateChange.bind(this);
    this.toDateChange = this.toDateChange.bind(this);
    this.formSubmit = this.formSubmit.bind(this);
    this.searchFilterChange = this.searchFilterChange.bind(this);
    this.getCreditdaysReport = this.getCreditdaysReport.bind(this);
    this.switchTab = this.switchTab.bind(this);
  }

  componentDidMount() {
    const obj_this = this;
    const url = `${process.env.REACT_APP_SSS}/api/getOutstandingDistricts`;

    this.context.loading(1);
    $.ajax({
      url: url,
      data: {
        sid: this.context.user_details.sid
      },
      type: "POST"
    }).done(function (return_data) {
      if (return_data.status === "success") {
        obj_this.setState({
          districts: return_data.districts || []
        });
      } else {
        obj_this.props.history.replace("/");
      }
    }).fail(function () {
      alert("Network error fetching districts");
    });

    this.getCreditdaysReport();

    requestAnimationFrame(() => {
      resetScroll('.outstanding_forecast_page_container');
    });
  }

  switchTab(tab) {
    this.setState({ active_tab: tab }, () => {
      window.scrollTo(0, 0);
      resetScroll('.outstanding_forecast_page_container');
    });
  }

  getCreditdaysReport() {
    const obj_this = this;
    const url = `${process.env.REACT_APP_SSS}/api/Reports/creditdaysReport`;
    this.context.loading(1);

    const postData = {
      sid: this.context.user_details.sid,
      till_date: this.state.till_date ? 1 : 0,
      to_date: this.state.to_date ? this.state.to_date.toLocaleDateString('en-CA') : ''
    };

    if (!this.state.till_date && this.state.from_date) {
      postData.from_date = this.state.from_date.toLocaleDateString('en-CA');
    }

    if (this.state.district && this.state.district.value) {
      postData.district_id = this.state.district.value;
    }

    if (this.state.customer && this.state.customer.value) {
      postData.customer_id = this.state.customer.value;
    }

    $.ajax({
      url: url,
      data: postData,
      type: "POST"
    }).done(function (return_data) {
      if (return_data.status === "success") {
        let cost_centers = return_data.cost_centers || [];

        // Maintain the master list of all available customers without losing options when filtering
        const masterCustomers = [...(obj_this.state.all_customers || [])];
        let hasNewCustomer = false;

        cost_centers.forEach((cc) => {
          if (cc.dealers && cc.dealers.length) {
            cc.dealers.forEach((d) => {
              const distId = (d.district_id !== undefined && d.district_id !== null)
                ? d.district_id
                : (cc.district_id || cc.id || cc.cost_center_id);
              const existingIdx = masterCustomers.findIndex((c) => String(c.value) === String(d.id));
              if (existingIdx === -1) {
                masterCustomers.push({
                  value: d.id,
                  label: d.name,
                  district_id: distId
                });
                hasNewCustomer = true;
              } else if (
                (masterCustomers[existingIdx].district_id === undefined || masterCustomers[existingIdx].district_id === null) &&
                distId !== undefined && distId !== null
              ) {
                masterCustomers[existingIdx].district_id = distId;
                hasNewCustomer = true;
              }
            });
          }
        });

        if (hasNewCustomer || obj_this.state.all_customers.length === 0) {
          masterCustomers.sort((a, b) => a.label.localeCompare(b.label));
        }

        // Filter cost centers having dealers with bills
        const filteredCostCenters = cost_centers
          .map((cc) => ({
            ...cc,
            dealers: (cc.dealers || []).filter((d) => d.bills && d.bills.length > 0)
          }))
          .filter((cc) => cc.dealers.length > 0);

        obj_this.setState({
          cost_centers: filteredCostCenters,
          showing_cost_centers: filteredCostCenters,
          all_customers: masterCustomers,
          outstanding: return_data.outstanding || 0,
          due_exceed: return_data.due_exceed || 0,
          bill_total: return_data.bill_total || 0,
          showing_outstanding: return_data.outstanding || 0,
          showing_due_exceed: return_data.due_exceed || 0,
          showing_bill_total: return_data.bill_total || 0,
          customer_search: "",
          invoice_search: ""
        });
        obj_this.context.loading(0);
      } else {
        obj_this.context.loading(0);
        obj_this.props.history.replace("/");
      }
    }).fail(function () {
      obj_this.context.loading(0);
      alert("Network error fetching report data");
    });
  }

  handleTillDateToggle(e) {
    this.setState({
      till_date: e.target.checked
    });
  }

  fromDateChange(value) {
    this.setState({ from_date: value });
  }

  toDateChange(value) {
    this.setState({ to_date: value });
  }

  districtChange(option) {
    this.setState((prevState) => {
      let updatedCustomer = prevState.customer;
      if (option && option.value !== undefined && option.value !== null && updatedCustomer) {
        const selectedDistId = String(option.value);
        const custMatches = prevState.all_customers.some(
          (c) => String(c.value) === String(updatedCustomer.value) &&
                 c.district_id !== undefined &&
                 c.district_id !== null &&
                 String(c.district_id) === selectedDistId
        );
        if (!custMatches) {
          updatedCustomer = null;
        }
      }
      return {
        district: option,
        customer: updatedCustomer
      };
    });
  }

  customerChange(option) {
    this.setState({ customer: option });
  }

  getFilteredCustomerOptions() {
    if (this.state.district && this.state.district.value !== undefined && this.state.district.value !== null) {
      const selectedDistId = String(this.state.district.value);
      return this.state.all_customers.filter(
        (c) => c.district_id !== undefined && c.district_id !== null && String(c.district_id) === selectedDistId
      );
    }
    return this.state.all_customers;
  }

  formSubmit(e) {
    e.preventDefault();
    this.getCreditdaysReport();
  }

  searchFilterChange(e) {
    const { name, value } = e.target;
    let custSearch = this.state.customer_search;
    let invSearch = this.state.invoice_search;

    if (name === "customer") {
      custSearch = value;
      this.setState({ customer_search: value });
    } else if (name === "invoice") {
      invSearch = value;
      this.setState({ invoice_search: value });
    }

    let grandBillTotal = 0;
    let grandOutstanding = 0;
    let grandOverdue = 0;

    const filteredCostCenters = this.state.cost_centers.map((cc) => {
      let ccBillTotal = 0;
      let ccOutstanding = 0;
      let ccOverdue = 0;

      const filteredDealers = cc.dealers
        .filter((d) => {
          if (!custSearch) return true;
          return d.name.toLowerCase().includes(custSearch.toLowerCase());
        })
        .map((d) => {
          let bills = d.bills;
          if (invSearch) {
            bills = bills.filter((b) =>
              b.bill_no.toLowerCase().includes(invSearch.toLowerCase())
            );
          }

          const dealerBillTotal = bills.reduce(
            (sum, b) => sum + parseFloat(b.bill_amount || 0),
            0
          );
          const dealerReceivable = bills.reduce(
            (sum, b) => sum + parseFloat(b.receivable || 0),
            0
          );
          const dealerOverdue = bills.reduce(
            (sum, b) => sum + parseFloat(b.exceed || 0),
            0
          );

          ccBillTotal += dealerBillTotal;
          ccOutstanding += dealerReceivable;
          ccOverdue += dealerOverdue;

          return {
            ...d,
            bills: bills,
            bill_total: dealerBillTotal,
            pending_total: dealerReceivable,
            exceed_due_total: dealerOverdue
          };
        })
        .filter((d) => d.bills.length > 0);

      grandBillTotal += ccBillTotal;
      grandOutstanding += ccOutstanding;
      grandOverdue += ccOverdue;

      return {
        ...cc,
        dealers: filteredDealers,
        sum_of_cost_center_bill_total: ccBillTotal,
        sum_of_cost_center_outstanding: ccOutstanding,
        sum_of_cost_center_overdue: ccOverdue
      };
    }).filter((cc) => cc.dealers.length > 0);

    this.setState({
      showing_cost_centers: filteredCostCenters,
      showing_bill_total: grandBillTotal,
      showing_outstanding: grandOutstanding,
      showing_due_exceed: grandOverdue
    });
  }

  formatCurrency(val) {
    const num = parseFloat(val) || 0;
    return num.toLocaleString('en-IN', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  formatDate(dateStr) {
    if (!dateStr) return "-";
    try {
      const parts = dateStr.split(" ")[0].split("-");
      if (parts.length === 3) {
        return `${parts[2]}-${parts[1]}-${parts[0]}`;
      }
      const d = new Date(dateStr.replace(/-/g, '/'));
      if (!isNaN(d.getTime())) {
        return d.toLocaleDateString('en-GB').replace(/\//g, '-');
      }
    } catch (err) {
      // fallback
    }
    return dateStr;
  }

  isOverdue(dueDateStr) {
    if (!dueDateStr) return false;
    try {
      const due = new Date(dueDateStr.replace(/-/g, '/'));
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      return due < today;
    } catch (e) {
      return false;
    }
  }

  render() {
    const rupee = '₹';

    return (
      <MyContext.Consumer>
        {context => (
          <div className="outstanding_forecast_page_container">
            {/* Header */}
            <div className="page_header">
              <Link className="back_button" to="/dashboard">
                <i className="fas fa-arrow-left"></i>
              </Link>
              <div className="page_title">Outstanding Forecast</div>
            </div>

            {/* Filter Form */}
            <form className="forecast_filter_form" onSubmit={this.formSubmit}>
              <div className="form_card">
                {/* Till Date Checkbox */}
                <div className="till_date_toggle_container">
                  <label className="checkbox_label">
                    <input
                      type="checkbox"
                      checked={this.state.till_date}
                      onChange={this.handleTillDateToggle}
                    />
                    <span>Till Date</span>
                    {this.state.till_date && (
                      <span className="till_date_badge">Outstanding till selected date</span>
                    )}
                  </label>
                </div>

                {/* Date Inputs Grid */}
                <div className="date_inputs_grid">
                  <div className={`date_group ${this.state.till_date ? 'disabled' : ''}`}>
                    <div className="input_label">From Date</div>
                    <DatePicker
                      className="custom_datepicker"
                      onChange={this.fromDateChange}
                      value={this.state.from_date}
                      clearIcon={null}
                      disabled={this.state.till_date}
                      format="dd-MM-y"
                    />
                  </div>

                  <div className="date_group">
                    <div className="input_label">To Date*</div>
                    <DatePicker
                      className="custom_datepicker"
                      onChange={this.toDateChange}
                      value={this.state.to_date}
                      minDate={!this.state.till_date && this.state.from_date ? new Date(this.state.from_date) : null}
                      clearIcon={null}
                      required
                      format="dd-MM-y"
                    />
                  </div>
                </div>

                {/* Dropdowns Grid: District & Customer */}
                <div className="dropdown_inputs_grid">
                  <div className="dropdown_group">
                    <div className="input_label">District (Cost Center)</div>
                    <Select
                      options={this.state.districts}
                      value={this.state.district}
                      className="react_select_input"
                      onChange={this.districtChange}
                      isClearable={true}
                      placeholder="All Districts"
                    />
                  </div>

                  <div className="dropdown_group">
                    <div className="input_label">Customer</div>
                    <Select
                      options={this.getFilteredCustomerOptions()}
                      value={this.state.customer}
                      className="react_select_input"
                      onChange={this.customerChange}
                      isClearable={true}
                      placeholder="All Customers"
                    />
                  </div>
                </div>

                {/* Submit Button */}
                <div className="submit_button_container">
                  <button type="submit" className="submit_button">
                    <i className="fas fa-filter"></i> Apply Filters
                  </button>
                </div>
              </div>
            </form>

            {/* Toggles */}
            <div className="toggles_container">
              <div
                className={`list_3 toggles ${this.state.active_tab === "0" ? "selected" : ""}`}
                onClick={() => this.switchTab("0")}
              >
                <i className="fa fa-credit-card order_status_icon"></i>
                <div className="order_status">Cost Center O/S</div>
              </div>
              <div
                className={`list_4 toggles ${this.state.active_tab === "1" ? "selected" : ""}`}
                onClick={() => this.switchTab("1")}
              >
                <i className="fa fa-list-alt order_status_icon"></i>
                <div className="order_status">Detailed Forecast</div>
              </div>
            </div>

            {/* View Containers with independent heights */}
            <div className="list_blocks_container">
              {/* Tab 0: Cost Center Summary Table (only renders when active, natural 15 rows height) */}
              {this.state.active_tab === "0" && (
                <div className="lists_container active_tab_pane">
                  <div className="cost_center_summary_card">
                    <div className="table_responsive">
                      <table className="cost_center_summary_table">
                        <thead>
                          <tr>
                            <th style={{ width: "35px", textAlign: "center" }}>#</th>
                            <th align="left" style={{ minWidth: "120px" }}>Cost Center</th>
                            <th align="right" style={{ minWidth: "105px" }}>Bill Total</th>
                            <th align="right" style={{ minWidth: "105px" }}>Outstanding</th>
                            <th align="right" style={{ minWidth: "105px" }}>Overdue</th>
                          </tr>
                        </thead>
                        <tbody>
                          {(!this.state.cost_centers || this.state.cost_centers.length === 0) ? (
                            <tr>
                              <td colSpan="5" align="center" style={{ padding: "20px" }}>
                                No results found for the selected criteria!
                              </td>
                            </tr>
                          ) : (
                            this.state.cost_centers.map((costCenter, ccIdx) => (
                              <tr key={ccIdx}>
                                <td align="center">{ccIdx + 1}</td>
                                <td>
                                  <b>{costCenter.district}</b>
                                </td>
                                <td align="right">
                                  {this.formatCurrency(costCenter.sum_of_cost_center_bill_total)} {rupee}
                                </td>
                                <td align="right">
                                  {this.formatCurrency(costCenter.sum_of_cost_center_outstanding)} {rupee}
                                </td>
                                <td align="right" className={costCenter.sum_of_cost_center_overdue > 0 ? "overdue_text" : ""}>
                                  {this.formatCurrency(costCenter.sum_of_cost_center_overdue)} {rupee}
                                </td>
                              </tr>
                            ))
                          )}

                          {this.state.cost_centers && this.state.cost_centers.length > 0 && (
                            <tr className="final_total_row">
                              <td colSpan={2} align="center">
                                <b>Total</b>
                              </td>
                              <td align="right">
                                <b>{this.formatCurrency(this.state.bill_total || this.state.showing_bill_total)} {rupee}</b>
                              </td>
                              <td align="right">
                                <b>{this.formatCurrency(this.state.outstanding || this.state.showing_outstanding)} {rupee}</b>
                              </td>
                              <td align="right" className="overdue_text">
                                <b>{this.formatCurrency(this.state.due_exceed || this.state.showing_due_exceed)} {rupee}</b>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              )}

              {/* Tab 1: Detailed Forecast by Cost Center & Customer */}
              {this.state.active_tab === "1" && (
                <div className="lists_container active_tab_pane">
                  {/* Search Bar */}
                  <div className="search_block">
                    <div className="search_container">
                      <CgSearch className="search_icon" />
                    <input
                      className="search_input"
                      placeholder="Search customer name..."
                      name="customer"
                      value={this.state.customer_search}
                      onChange={this.searchFilterChange}
                    />
                  </div>
                  <div className="search_container">
                    <CgSearch className="search_icon" />
                    <input
                      className="search_input"
                      placeholder="Search bill / invoice no..."
                      name="invoice"
                      value={this.state.invoice_search}
                      onChange={this.searchFilterChange}
                    />
                  </div>
                </div>

                {this.state.showing_cost_centers.length === 0 ? (
                  <div className="empty_state_box">
                    <div className="empty_state_icon">
                      <i className="fas fa-file-invoice-dollar"></i>
                    </div>
                    <div className="empty_state_text">No outstanding forecast data found!</div>
                  </div>
                ) : (
                  this.state.showing_cost_centers.map((costCenter, ccIdx) => (
                    <div className="cost_center_group_card" key={ccIdx}>
                      {/* Cost Center Header */}
                      <div className="cost_center_header">
                        <div className="cost_center_title">
                          <i className="fas fa-map-marker-alt"></i>
                          Cost Center: {costCenter.district}
                        </div>
                        <div className="cost_center_badge">
                          {costCenter.dealers.length} {costCenter.dealers.length === 1 ? 'Customer' : 'Customers'}
                        </div>
                      </div>

                      {/* Customers and Bills */}
                      <div className="cost_center_body">
                        {costCenter.dealers.map((customer, custIdx) => (
                          <div className="customer_card" key={custIdx}>
                            {/* Customer Header */}
                            <div className="customer_header">
                              <div className="customer_name_wrapper">
                                <strong>{custIdx + 1}. </strong>{" "}
                                <span>{customer.name}</span>
                              </div>
                              <div className="customer_header_right">
                                {customer.credit_note > 0 && (
                                  <span className="credit_note_badge">
                                    CN: {customer.credit_note} {rupee}
                                  </span>
                                )}
                                <span className="credit_period_badge">
                                  Credit Period: <b>{customer.credit_period || 30} Days</b>
                                </span>
                              </div>
                            </div>

                            {/* Bills Table */}
                            <div className="table_responsive">
                              <table className="bills_table">
                                <thead>
                                  <tr>
                                    <th style={{ width: '40px', textAlign: 'center' }}>Sl No</th>
                                    <th style={{ minWidth: '85px', textAlign: 'center' }}>Bill Date</th>
                                    <th style={{ minWidth: '110px', textAlign: 'center' }}>Bill No</th>
                                    <th style={{ minWidth: '95px', textAlign: 'right' }}>Bill Amount</th>
                                    <th style={{ minWidth: '105px', textAlign: 'right' }}>Receivable Amount</th>
                                    <th style={{ minWidth: '85px', textAlign: 'center' }}>Due Date</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {customer.bills.map((bill, billIdx) => {
                                    const overdue = this.isOverdue(bill.due_date || bill.bill_due_date);
                                    return (
                                      <tr key={billIdx} className={overdue ? "overdue_row" : ""}>
                                        <td align="center">{billIdx + 1}</td>
                                        <td align="center">{this.formatDate(bill.bill_date)}</td>
                                        <td>{bill.bill_no}</td>
                                        <td align="right">
                                          {this.formatCurrency(bill.bill_amount)}{" "}
                                          <span className="currency_symbol">{rupee}</span>
                                        </td>
                                        <td align="right" className="receivable_cell">
                                          {this.formatCurrency(bill.receivable)}{" "}
                                          <span className="currency_symbol">{rupee}</span>
                                        </td>
                                        <td align="center" className={overdue ? "overdue_date" : ""}>
                                          {this.formatDate(bill.due_date || bill.bill_due_date)}
                                        </td>
                                      </tr>
                                    );
                                  })}
                                </tbody>
                                <tfoot>
                                  <tr className="customer_subtotal_row">
                                    <td colSpan={3} className="subtotal_label" align="right">
                                      Customer Subtotal:
                                    </td>
                                    <td align="right">
                                      {this.formatCurrency(
                                        customer.bill_total ||
                                        customer.bills.reduce((sum, b) => sum + parseFloat(b.bill_amount || 0), 0)
                                      )}{" "}
                                      <span className="currency_symbol">{rupee}</span>
                                    </td>
                                    <td align="right" className="subtotal_receivable">
                                      {this.formatCurrency(
                                        customer.pending_total ||
                                        customer.bills.reduce((sum, b) => sum + parseFloat(b.receivable || 0), 0)
                                      )}{" "}
                                      <span className="currency_symbol">{rupee}</span>
                                    </td>
                                    <td align="center">-</td>
                                  </tr>
                                </tfoot>
                              </table>
                            </div>
                          </div>
                        ))}
                      </div>

                      {/* Cost Center Total Bar */}
                      <div className="cost_center_total_bar">
                        <div className="cost_center_total_title">
                          Cost Center Total ({costCenter.district}):
                        </div>
                        <div className="cost_center_total_metrics">
                          <span>
                            Bill Total: <b>{this.formatCurrency(costCenter.sum_of_cost_center_bill_total)} {rupee}</b>
                          </span>
                          <span>
                            Receivable: <b>{this.formatCurrency(costCenter.sum_of_cost_center_outstanding)} {rupee}</b>
                          </span>
                          {costCenter.sum_of_cost_center_overdue > 0 && (
                            <span className="overdue_metric">
                              Overdue: <b>{this.formatCurrency(costCenter.sum_of_cost_center_overdue)} {rupee}</b>
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                  ))
                )}

                {/* Grand Total Card */}
                {this.state.showing_cost_centers.length > 0 && (
                  <div className="grand_total_card">
                    <div className="grand_total_title">Grand Total Summary:</div>
                    <div className="grand_total_metrics">
                      <div className="metric_item">
                        <span className="metric_label">Total Bill Amount:</span>
                        <span className="metric_val">
                          {this.formatCurrency(this.state.showing_bill_total)} {rupee}
                        </span>
                      </div>
                      <div className="metric_item">
                        <span className="metric_label">Total Receivable Amount:</span>
                        <span className="metric_val receivable_text">
                          {this.formatCurrency(this.state.showing_outstanding)} {rupee}
                        </span>
                      </div>
                      <div className="metric_item">
                        <span className="metric_label">Total Overdue Amount:</span>
                        <span className="metric_val overdue_text">
                          {this.formatCurrency(this.state.showing_due_exceed)} {rupee}
                        </span>
                      </div>
                    </div>
                  </div>
                )}
              </div>
              )}
            </div>
            <div className="bottom_navbar_spacer"></div>
          </div>
        )}
      </MyContext.Consumer>
    );
  }
}

export default OutstandingForecast;
OutstandingForecast.contextType = MyContext;
